import React from "react"
import Image from "gatsby-image"
// import CloudinaryVideo from "./../cloudinaryvideo"
import loadable from "@loadable/component";

const CloudinaryVideo = loadable(() => import("../cloudinaryvideo"), {
  ssr: false, // Disables Server-Side Rendering
});

const textAndImage = ({ content }) => {
  const portraitImage = {
    fluid: content.primaryImage?.image?.localFile?.childImageSharp?.fluid,
    alt: content.image?.altText,
  }
  const landscapeImage = {
    fluid: content.secondaryImage?.image?.localFile?.childImageSharp?.fluid,
    alt: content.image?.altText,
  }
  
  return (
    <div className="relative flex flex-col items-start py-24">
      <div
        className={`tab:w-7/12 desk:w-6/12 mb-16 tab:mb-0 ${
          content.reverseLayout ? `` : `tab:ml-auto`
        }`}
      >
        <h2 className="font-sans text-mobmd desk:text-lg font-normal pb-12">
          {content.title}
        </h2>
        <p className="med:w-8/12 desk:w-10/12 whitespace-pre-line">
          {content.text}
        </p>
      </div>
      <div
        className={`w-full flex flex-col items-center justify-between ${
          content.reverseLayout
            ? `flex-col-reverse med:flex-row-reverse`
            : `med:flex-row`
        }`}
      >
        {content.primaryImage?.imageType === "image" ? (
          <>
            {content.primaryImage?.image?.localFile?.childImageSharp?.fluid && (
              <Image
                fluid={portraitImage.fluid}
                alt={portraitImage.alt}
                className="w-full med:w-64 desk:w-108 transform tab:-translate-y-16 desk:-translate-y-28 h-96 desk:h-136"
              />
            )}
          </>
        ) : (
          <>
            {content.primaryImage?.anim && (
              <div className="flex items-center justify-center w-full med:w-64 desk:w-108 transform tab:-translate-y-16 desk:-translate-y-28 h-96 desk:h-136">
                <CloudinaryVideo
                  publicUrl={content.primaryImage.anim}
                  class_list="h-full w-full object-cover"
                />
              </div>
            )}
          </>
        )}

        {content.secondaryImage?.imageType === "image" ? (
          <>
            {content.secondaryImage?.image?.localFile?.childImageSharp
              ?.fluid && (
              <Image
                fluid={landscapeImage.fluid}
                alt={landscapeImage.alt}
                className={`w-full med:w-96 desk:w-144 h-60 desk:h-96 tab:mt-auto  ${
                  content.reverseLayout ? `mb-14` : `mt-14`
                }`}
              />
            )}
          </>
        ) : (
          <>
            {content.secondaryImage?.anim && (
              <div
                className={`flex items-center justify-center w-full med:w-96 desk:w-144 h-60 desk:h-96 tab:mt-auto  ${
                  content.reverseLayout ? `mb-14` : `mt-14`
                }`}
              >
                <CloudinaryVideo
                  publicUrl={content.secondaryImage.anim}
                  class_list="h-full w-full object-cover"
                />
              </div>
            )}
          </>
        )}

        {/* <Image
          fluid={landscapeImage.fluid}
          alt={landscapeImage.alt}
          className={`w-full med:w-96 desk:w-144 h-60 desk:h-96 tab:mt-auto  ${
            content.reverseLayout ? `mb-14` : `mt-14`
          }`}
        /> */}
      </div>
    </div>
  )
}

export default textAndImage
